import { getIsSeller } from '@app/ducks';
import { convertPageToLatestVersion, latestPageStructureVersion } from '@app/logic/cms/convertPageToLatestVersion';
import { getPageBySlug } from '@app/services/pagesRepository';
import { isDefined } from '@app/utils/is';
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

interface Props {
  pageSlug: string;
  buyerId?: string;
}

export const PAGE_BY_SLUG_QUERY_KEY = 'pageBySlug';

export const usePageBySlug = ({ pageSlug, buyerId }: Props) => {
  const isSeller = useSelector(getIsSeller);

  return useQuery({
    queryFn: async () => {
      const responseData = await getPageBySlug(pageSlug, isSeller ? buyerId : undefined);
      if ((responseData.version ?? 0) > latestPageStructureVersion) {
        window.location.reload();

        throw new Error('CMS version not supported, reloading page');
      }

      return responseData;
    },
    queryKey: [PAGE_BY_SLUG_QUERY_KEY, { pageSlug }],
    select: data => {
      if (!isDefined(data) || (data.version ?? 0) > latestPageStructureVersion) {
        return {
          ...data,
          blocks: {},
          groups: {},
          localizations: undefined,
          sections: [],
        };
      }
      const { localizations, sections } = convertPageToLatestVersion(data);

      return {
        ...data,
        localizations,
        sections,
      };
    },
  });
};
